import React from 'react';

const ArrowChartSkeleton = () => {
  return (

    <div class="flex flex-col items-center justify-center max-w-xl mx-auto p-2 animate-pulse">
      <p class="text-sm font-semibold mx-2 bg-gray-200 rounded h-6 w-3/4"></p>
      <div class="flex items-center justify-between w-full h-20">
        <div class="w-1/2 flex justify-end items-center h-full p-2">
          <div class="bg-gray-200 h-full w-3/4 rounded-r-lg"></div>
        </div>
        <div class="w-1/2 flex justify-start items-center h-full p-2">
          <div class="bg-gray-200 h-full w-3/4 rounded-l-lg"></div>
        </div>
      </div>
    </div>
  )
}

export default ArrowChartSkeleton;